module.exports = __webpack_public_path__ + "fonts/Prompt-BoldItalic.4d9bc9c7.ttf";